var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.19 17.75h-10.65001c-.99 0-1.94-.42-2.61-1.15s-1.00999-1.71-.92999-2.7l.83-9.96c.03-.31-.08001-.60999-.29001-.83999s-.49999-.35001-.80999-.35001h-1.73c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.74001c.73 0 1.41998.31 1.90998.84.27.3.47001.65.58001 1.04h12.49c1.01 0 1.94.4 2.62 1.12.67.73 1.01 1.68.93 2.69l-.54 7.5c-.11 1.83-1.71 3.31-3.54 3.31zm-11.91-13.13-.78 9.4c-.05.58.14 1.13.53 1.56s.92999.66 1.50999.66h10.65001c1.04 0 1.98-.88 2.06-1.92l.54-7.49999c.04-.59-.15-1.15-.54-1.56-.39-.42-.93-.65002-1.52-.65002h-12.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.25 22.75c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-2.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.25 22.75c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-2.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21 8.75h-12c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.c73e743327d500497fb192d69076dbca.svg";
export { ForwardRef as ReactComponent };